import DetectMobileBrowsers from '../../utils/detect-mobile-browsers';
import Termin from './termin';
import TerminMobile from './termin-mobile';

(() => {
    if (typeof $ === 'undefined') {
        throw new TypeError('... requires jQuery.');
    }

    $(document).ready(() => {
        const isMobileBrowser = DetectMobileBrowsers.check();

        if (isMobileBrowser) {
            const terminMobile = new TerminMobile();

            terminMobile.init();
        } else {
            const termin = new Termin();

            termin.init();
        }
    });
})();
